import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { SavingsHandlerComponent } from "../savings-handler.component";
import { AccountService } from "../../../account/services/account.service";
import { SavingsService } from "@main-services/savings.service";
import { UserService } from "@main-services/user.service";
import { StockTestService } from "@main-services/stock-test.service";
import { StockTestHelperService } from "@main-services/stock-test-helper.service";

@Component({
	selector: "savings-empty",
	templateUrl: "./savings-empty.component.html",
	styleUrls: ["./savings-empty.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SavingsEmptyComponent extends SavingsHandlerComponent {
	public constructor(
		protected modalService: ModalService,
		protected tradableWalletListService: TradableWalletListService,
		protected savingsService: SavingsService,
		protected accountService: AccountService,
		protected userService: UserService,
		protected stockTestService: StockTestService,
		protected stockTestHelperService: StockTestHelperService
	) {
		super(
			tradableWalletListService,
			modalService,
			savingsService,
			accountService,
			userService,
			stockTestService,
			stockTestHelperService
		);
	}

	public showMaintenance(): boolean {
		return this.savingsDisabled && this.userIsVerified;
	}

	public get userIsVerified(): boolean {
		return this.userService.user.isVerified();
	}
}
